<template>
    <div>
        <vs-popup title="Uredi jed" :active.sync="promptOpen" v-if="foodItem && additions && options">
            <div>
                <div :key="index" v-for="(option, index) in options">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <span class="text-xl font-medium">{{option.name}}</span>
                            <div class="flex flex-wrap items-center mt-2">
                                <ul style="display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center;">
                                    <li class="mr-4" :key="index" v-for="(item, index) in option.items">
                                        <vs-radio :vs-name="option.name" v-model="selectedOptions[option.id]" :vs-value="item.id">{{item.item_name}}</vs-radio>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <vs-divider />
                </div>
                <h5 class="mt-6 mb-2">Dodatni opis</h5>
                <p>(Ni namenjeno spremembam dodatkov - ti se izberejo v tabeli nižje!)</p>
                <vs-textarea v-model="editItem.additional_comments"/>
                <h5 class="mt-6">Dodatki</h5>
                <vs-table noDataText="Ni dodatkov" ref="tableAdditions" v-model="editItem.additions" multiple pagination search :max-items="50" :data="additions">

                    <template slot="thead">
                        <vs-th sort-key="name">Ime</vs-th>
                        <vs-th sort-key="price">Cena</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <tbody>
                        <vs-tr :data="tr.id" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].name">
                                {{ data[index].name }}
                            </vs-td>

                            <vs-td :data="data[index].price">
                                <vs-chip v-if="foodItem.included_additions.includes(data[index].id)" color="success">Vključeno v ceno</vs-chip>
                                <p v-else>{{ data[index].price }}</p>
                            </vs-td>

                        </vs-tr>
                        </tbody>
                    </template>

                </vs-table>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="editFood">Shrani</vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>

    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
        },
        data(){
            return {

                editItem: null,
                foodItem: null,
                additions: [],
                options: [],

                promptOpen: false,

                selectedOptions: {},

            }
        },
        methods: {
            openPrompt(obj){
                this.editItem = JSON.parse(JSON.stringify(obj));
                this.selectedOptions = JSON.parse(JSON.stringify(obj.options));
                this.updateItem();
                this.promptOpen = true;
            },
          updateItem(){

              const thisIns = this;

              this.$http.get('/api/listing/v1/food/' + this.editItem.food_id)
                  .then(function (response) {
                      thisIns.foodItem = response.data;
                  })
                  .catch(function (error) {
                      thisIns.$vs.notify({
                          title: 'Error',
                          text: error,
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-alert-circle'
                      })
                  });

              this.$http.get('/api/listing/v1/food/' + this.editItem.food_id + "/addition")
                  .then(function (response) {
                      thisIns.additions = response.data;
                  })
                  .catch(function (error) {
                      thisIns.$vs.notify({
                          title: 'Error',
                          text: error,
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-alert-circle'
                      })
                  });

              this.$http.get('/api/listing/v1/food/' + this.editItem.food_id + "/option")
                  .then(function (response) {
                      thisIns.options = response.data;
                      for(let x = 0; x < thisIns.options; x++){
                          thisIns.selectedOptions[thisIns.options[x].id] = thisIns.options[x].items[0];
                      }
                  })
                  .catch(function (error) {
                      thisIns.$vs.notify({
                          title: 'Error',
                          text: error,
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-alert-circle'
                      })
                  });
          },
            editFood(){
                const thisIns = this;

                this.$http.put('/api/order/v1/cart/' + this.editItem.id, {
                    additional_comments: this.editItem.additional_comments,
                    options: this.selectedOptions,
                    additions: this.editItem.additions,
                })
                    .then(function () {
                        thisIns.$emit('item-updated');
                        thisIns.promptOpen = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            }
        },
        watch: {
            item(){
                this.editItem = JSON.parse(JSON.stringify(this.item));
                this.selectedOptions = this.editItem.options;
                this.updateItem();
                this.promptOpen = true;
            },
        },
    }

</script>
